import {toggle} from 'opticks'

import {useGetBoVioConfiguration} from './useGetBoVioConfiguration'
interface Props {
  boVioUrl: string
  // BoVio API key
  boVioProfile: string
  boVioProfileClExperiment: string
}

/**
 * This component triggers request to BoVio API offers/configurations endpoint.
 * Received configuration is stored in session storage and needed to check offers eligibility for deal freeze and charge later.
 * After that configuration become accessible via useGetBoVioConfiguration hook.
 */

export const GetBoVioConfiguration = ({
  boVioUrl,
  boVioProfile,
  boVioProfileClExperiment
}: Props) => {
  const profile = toggle(
    '169ce369-cl-eligibility',
    boVioProfile,
    boVioProfileClExperiment
  )
  useGetBoVioConfiguration({boVioUrl, boVioProfile: profile})
  return null
}
